import { render, staticRenderFns } from "./createFeeByComboList.vue?vue&type=template&id=6f853e52&scoped=true"
import script from "./createFeeByComboList.vue?vue&type=script&lang=js"
export * from "./createFeeByComboList.vue?vue&type=script&lang=js"
import style0 from "./createFeeByComboList.vue?vue&type=style&index=0&id=6f853e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f853e52",
  null
  
)

export default component.exports